<template>
    <div>
        <div>
            <div class="tw-bg-gray-50 tw-pt-3 tw-pb-3 tw-mb-8 tw-rounded-lg">
                <span class="tw-font-semibold tw-pl-4 tw-uppercase">
                    {{ this.$t("teamDashboard.reviewAnalyticsTitle") }}
                </span>
                <span class="color-grey">
                    {{ this.$t("teamDashboard.reviewAnalyticsSubtitle") }}
                </span>
            </div>
            <l-skeleton-loader v-if="isLoading" />
            <div v-else>
                <l-reviews-analytics-snapshot
                    :ref="`chart-snapshot`"
                    :report-loading="isLoading"
                    :is-comparison-enabled="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSkeletonLoader from "@/components/LSkeletonLoader";
import LReviewsAnalyticsSnapshot from "@/components/LReviewsAnalyticsSnapshot";

export default {
    components: {
        LSkeletonLoader,
        LReviewsAnalyticsSnapshot,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            query: {},
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            report: "reviews/analytics/report",
        }),
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.query = {
                viewAs: "owner",
                format: "snapshot",
                mode: "default",
                source: "reviews",
                filters: {
                    primary: {
                        users: [],
                        periods: [
                            { start: this.$moment().subtract(1, "year"), end: this.$moment() },
                        ],
                        admin: ["directReportsOnly"],
                    },
                    secondary: {},
                },
                enableSecondaryFilters: false,
                groupBy: "user",
                dimensionType: "skill",
                dimensionShowDeactivated: false,
                dimensionIncludeCustomQuestions: false,
                ignoreSafeguard: false,
                allowFallbackToFeedback: false,
            };

            await this.$store.dispatch({
                type: "reviews/analytics/getReport",
                payload: { query: this.query },
            });

            this.isLoading = false;
        },
    },
};
</script>
